export const makeOnDragEndFunction = fields => result => {
    // dropped outside the list
    if (!result.destination) {
        return;
    }
    fields.move(result.source.index, result.destination.index);
};
